import { render, staticRenderFns } from "./SchoolBusOrder.vue?vue&type=template&id=3877d464&scoped=true&"
import script from "./SchoolBusOrder.vue?vue&type=script&lang=js&"
export * from "./SchoolBusOrder.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBusOrder.vue?vue&type=style&index=0&id=3877d464&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3877d464",
  null
  
)

export default component.exports